const supportingOrgs = [
  { key: 'ghkm', img: '/2018/images/logo/ghkm.png', href: 'https://ghkmbayarea.org/about-us-2/' },
  { key: 'astri', img: '/2018/images/logo/astri.png', href: 'https://www.astri.org/' },
  { key: 'hkgcye', img: '/2018/images/logo/hkgcye.png', href: 'http://www.hkgcye.org.hk/' },
  { key: 'hkna', img: '/2018/images/logo/hkna.png', href: 'https://www.hkna.net/' },
  { key: 'hkpc', img: '/2018/images/logo/hkpc.png', href: 'https://www.hkpc.org/en/corporate-info/about-hkpc' },
  { key: 'rtia', img: '/2018/images/logo/rtia.png', href: 'http://www.hkrtia.org/' },
  { key: 'hkstp', img: '/2018/images/logo/hkstp.png', href: 'https://www.hkstp.org/en' },
  { key: 'wtia', img: '/2018/images/logo/wtia.png', href: 'http://wtiahk.org/' },
  { key: 'lscm', img: '/2018/images/logo/lscm.png', href: 'https://www.lscm.hk/eng/' },
  { key: 'tin', img: '/2018/images/logo/tin.png' },
  { key: 'acmcp', img: '/2018/images/logo/acmcp.png', href: 'http://www.acmcp.org/' },
  { key: 'cma', img: '/2018/images/logo/cma.png', href: 'http://www.cma.org.hk/' },
  { key: 'fhki', img: '/2018/images/logo/fhki.png', href: 'https://www.industryhk.org/en/' },
];

export const Footer2018 = ({ lang }: { lang: 'en' | 'zh' }) => {
  const isZh = lang === 'zh';
  const yearUrl = isZh ? 'https://smartcityslpa.etnet.com.hk/2018/zh' : 'https://smartcityslpa.etnet.com.hk/2018';
  const encodedYearUrl = encodeURIComponent(yearUrl);
  const encodedText = encodeURIComponent(yearUrl);

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer.php?u=${encodedYearUrl}`,
    whatsapp: `https://wa.me/?text=${encodedText}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedYearUrl}`,
    weibo: `https://service.weibo.com/share/share.php?url=${encodedYearUrl}`,
    line: `https://social-plugins.line.me/lineit/share?url=${encodedYearUrl}`,
  };

  return (
    <div id="footer">
      <div className="sponsors_footer_container footer_container">
        <div className="footer_small_container">
          <div className="logo_share_container">
            <a href="/2018">
              <div className="footer_logo">
                <img src="/2018/images/head_logo_4.png" alt="" />
              </div>
            </a>
            <a href="/2018/contact_us" style={{ textDecoration: 'none' }}>
              <div className="footer_share footer_contact">{isZh ? '聯絡' : 'Contact Us'}</div>
            </a>
            <div className="footer_share footer_divider">|</div>
            <div className="footer_share">{isZh ? '分享到' : 'Share to'}</div>
            <div className="share_btn">
              <a id="sharetoFacebook" className="share_btn share_btn2 facebook" href={shareLinks.facebook} target="_blank" rel="noreferrer">
                <img src="/2018/images/fb.png" alt="" />
              </a>
              <a id="sharetoWhatsapp" className="share_btn share_btn2 whatsapp" href={shareLinks.whatsapp} target="_blank" rel="noreferrer">
                <img src="/2018/images/whatsapp.png" alt="" />
              </a>
              <a id="sharetoLinkedin" className="share_btn share_btn2 linkedin" href={shareLinks.linkedin} target="_blank" rel="noreferrer">
                <img src="/2018/images/linkedin.png" alt="" />
              </a>
              <a id="sharetoWeibo" className="share_btn share_btn2 weibo" href={shareLinks.weibo} target="_blank" rel="noreferrer">
                <img src="/2018/images/weibo.png" alt="" />
              </a>
              <a id="sharetoLine" className="share_btn share_btn2 whatsapp line" href={shareLinks.line} target="_blank" rel="noreferrer">
                <img src="/2018/images/line.png" alt="" />
              </a>
            </div>
          </div>
        </div>

        <div className="org_logo_container">
          <div className="org_logo_container_1">
            <div className="organiser etnet">
              {isZh ? '主辦機構' : 'Organiser'}
              <a href="http://www.etnet.com.hk" target="_blank" rel="noreferrer">
                <div className="organiser">
                  <img src="/2018/images/logo/etnet.png" alt="" />
                </div>
              </a>
            </div>

            <div className="organiser co-organiser">
              {isZh ? '協辦機構' : 'Co-organiser'}
              <div className="co-organiser">
                <a href="http://www.cyberport.hk/en" target="_blank" rel="noreferrer">
                  <img src="/2018/images/logo/cyberport.png" alt="" />
                </a>
              </div>
            </div>

            <div className="organiser strategic_partner">
              {isZh ? '策略伙伴' : 'Strategic Partners'}
              <div className="strategic_partner">
                <a href="https://www.gs1hk.org/" target="_blank" rel="noreferrer">
                  <img src="/2018/images/logo/gs1.png" alt="" />
                </a>
                <a href="https://smartcity.org.hk/" target="_blank" rel="noreferrer">
                  <img src="/2018/images/logo/scc.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="org_logo_container_2">
          <div className="supporting organiser">
            {isZh ? '支持機構' : 'Supporting Organisations'}
            <div className="supporting_organiser">
              {supportingOrgs.map((o) =>
                o.href ? (
                  <a key={o.key} href={o.href} target="_blank" rel="noreferrer">
                    <img src={o.img} alt="" />
                  </a>
                ) : (
                  <img key={o.key} src={o.img} alt="" />
                ),
              )}
            </div>
            <div className="order">{isZh ? '排名不分先後' : 'In no particular order'}</div>
          </div>
        </div>

        <div className="disclaimer">
          {isZh ? '© 2018 經濟通有限公司 版權所有 不得轉載' : '© 2018 ET Net Limited. All rights reserved.'} |{' '}
        </div>
      </div>
    </div>
  );
};

